export const DarkTheme: any = {
  background: {
    main: "#121B2C",
    primary: "#1E293B",
    hoverMain: "#1A2337",
    hoverPrimary: "#273449", 
    shadow: "rgba(255, 255, 255, 0.05)",
  },
  border: {
    main: "#2B374B",
    light: "#dbe0e6",
    dark: "#2B374B",
  },
  primary: {
    main: "#3D68FF",
    light: "rgb(29, 32, 33)",
    dark: "#3D68FF",
  },
  text: {
    main: "#fff",
    primary: "#B0B3B8",
    light: "#000",
    dark: "#fff",
    secondary: "#B0B3B8",
    muted: "#8B90A5",
    link: "#3D68FF",
    danger: "#e34a29",
    success: "#28D94F",
    warning: "#FBB500",
    info: "#26adf8",
    inverse: "#121B2C",
  },
  secondary: {
    main: "#949494",
    light: "rgb(29, 32, 33)",
    medium: "#8B90A5",
    dark: "#fff",
  },
  form: {
    main: "#eef3f7",
    light: "rgb(29, 32, 33)",
    dark: "#e4e6ef50",
  },
  success: {
    main: "#8be68b",
    light: "#E8FFF3",
    dark: "#47be85",
    medium: "#28D94F",
  },
  black: {
    main: "rgb(255, 255, 255) ",
    dark: "#fff",
    light: "rgb(200, 200, 200) ",
  },
  white: {
    main: "#121B2C",
    light: "#1E293B",
    dark: "#Fff",
  },
  error: {
    main: "#e34a29",
    light: "#FFF5F8",
    medium: "#FB5D5D",
    dark: "#FC0707",
  },
  info: {
    main: "#095379",
    light: "#26adf8",
    dark: "#313649",
    medium: "#890fe9",
  },
  warning: {
    main: "#FBB500",
    light: "#ffd47f",
    dark: "#d4c140",
  },

  transparent: "transparent",
};
